import StoresResources from './stores_resources.vue';

export default StoresResources;
